<template>
<div class="chapter">
<div class="inner_page">
<blockquote class="sink">
<p class="center "><em>For my Golden Classmates,</em></p>
<p class="center spaceabove1"><em>our teachers,</em></p>
<p class="center spaceabove1"><em>and our patients</em></p>
</blockquote>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// front02.vue?39c60c06